import Typography from "@shared/v2/Typography";
import TextComboInput from "@shared/v2/TextComboInput";
import Alert from "@shared/v2/Alert";
import { ChartMixedSolidV6 } from "@shared/v2/Icomoon";
import Button from "@shared/v2/Button";
import { SettingsSection } from "./types";
import { useCurrentUser } from "../../../reducers/layoutReducer/selectors";

const ProductivitySettings = ({ onChange, productionGoals }: SettingsSection) => {
  const {
    account: { isPlace, isLever },
  } = useCurrentUser() as { account: { isPlace: boolean; isLever: boolean } };
  const isBrivity = !isPlace && !isLever;

  return (
    <div className="tw-flex tw-flex-col tw-gap-[24px]">
      {/* @ts-expect-error props */}
      <Typography>
        Team defaults for <b>Productivity</b> are used to provide new agents with a baseline set of values
        when they are setting their <b>Activity Goals</b> via Business Planning (Help Me Set My Goals)
      </Typography>

      <div className="tw-flex tw-gap-[24px]">
        {/* @ts-expect-error props */}
        <TextComboInput
          isRequired
          containerClassName="tw-flex-1"
          label="Brivity Calls in the last 12 months"
          name="callsLastTwelveMonths"
          onChange={onChange}
          value={productionGoals.goals.callsLastTwelveMonths}
          error={productionGoals.errors.callsLastTwelveMonths}
        />
        {/* @ts-expect-error props */}
        <TextComboInput
          isRequired
          containerClassName="tw-flex-1"
          label="Contacts in the last 12 months"
          name="contactsLastTwelveMonths"
          onChange={onChange}
          value={productionGoals.goals.contactsLastTwelveMonths}
          error={productionGoals.errors.contactsLastTwelveMonths}
        />
      </div>

      <div className="tw-flex tw-gap-[24px]">
        {/* @ts-expect-error props */}
        <TextComboInput
          isRequired
          containerClassName="tw-flex-1"
          label="Appointments Set in the last 12 months"
          name="appointmentsSetLastTwelveMonths"
          onChange={onChange}
          value={productionGoals.goals.appointmentsSetLastTwelveMonths}
          error={productionGoals.errors.appointmentsSetLastTwelveMonths}
        />
        {/* @ts-expect-error props */}
        <TextComboInput
          isRequired
          containerClassName="tw-flex-1"
          label="Appointments Held in the last 12 months"
          name="appointmentsHeldLastTwelveMonths"
          onChange={onChange}
          value={productionGoals.goals.appointmentsHeldLastTwelveMonths}
          error={productionGoals.errors.appointmentsHeldLastTwelveMonths}
        />
      </div>

      <div className="tw-flex tw-gap-[24px]">
        {/* @ts-expect-error props */}
        <TextComboInput
          isRequired
          containerClassName="tw-flex-1"
          label="Signings in the last 12 months"
          name="signingsLastTwelveMonths"
          onChange={onChange}
          value={productionGoals.goals.signingsLastTwelveMonths}
          error={productionGoals.errors.signingsLastTwelveMonths}
        />
        {/* @ts-expect-error props */}
        <TextComboInput
          isRequired
          containerClassName="tw-flex-1"
          label="Units Pended in the last 12 months"
          name="unitsPendedLastTwelveMonths"
          onChange={onChange}
          value={productionGoals.goals.unitsPendedLastTwelveMonths}
          error={productionGoals.errors.unitsPendedLastTwelveMonths}
        />
      </div>

      <div className="tw-flex tw-gap-[24px]">
        {/* @ts-expect-error props */}
        <TextComboInput
          isRequired
          containerClassName="tw-flex-1"
          label="Units Closed in the last 12 months"
          name="unitsClosedLastTwelveMonths"
          onChange={onChange}
          value={productionGoals.goals.unitsClosedLastTwelveMonths}
          error={productionGoals.errors.unitsClosedLastTwelveMonths}
        />
        <span className="tw-flex-1" />
      </div>

      <Alert
        variant={isBrivity ? "brivity" : "info"}
        icon={<ChartMixedSolidV6 size="l" />}
        containerClass="tw-text-12d"
        text={
          <div className="tw-flex tw-gap-[16px] tw-justify-between tw-items-center tw-w-full">
            <div className="tw-flex tw-flex-col">
              <b>Not sure what values to use?</b>
              <div>
                View team stats in the <b>Sales Funnel</b> on the <b>Business Dashboard</b>
              </div>
            </div>
            {/* @ts-expect-error props */}
            <Button
              schema="secondary"
              onClick={() => window.open("/agent_stats?report_tab=businessDashboard", "_blank")}
            >
              Take Me There
            </Button>
          </div>
        }
      />
    </div>
  );
};

export default ProductivitySettings;
